/* Bella.Musa — interacciones */
(function(){
  const $=(s,c)=>(c||document).querySelector(s);
  const $$=(s,c)=>[...(c||document).querySelectorAll(s)];
  const money=c=>{
    const v=(c/100).toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2});
    return v+' €';
  };

  /* --- menú móvil --- */
  const scrim=$('#bmScrim'), mob=$('#bmMobnav');
  const closeAll=()=>{mob&&mob.classList.remove('is-open');cart&&cart.classList.remove('is-open');scrim&&scrim.classList.remove('is-open');document.body.style.overflow=''};
  $('#bmBurger')&&$('#bmBurger').addEventListener('click',()=>{mob.classList.add('is-open');scrim.classList.add('is-open');document.body.style.overflow='hidden'});
  scrim&&scrim.addEventListener('click',closeAll);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll()});

  /* --- carrito lateral --- */
  const cart=$('#bmCart'), body=$('#bmCartBody'), foot=$('#bmCartFoot'), count=$$('.bm-cartcount');
  function openCart(){cart.classList.add('is-open');scrim.classList.add('is-open');document.body.style.overflow='hidden'}
  $$('[data-bm-cart]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openCart();render()}));
  $('#bmCartClose')&&$('#bmCartClose').addEventListener('click',closeAll);

  async function getCart(){const r=await fetch('/cart.js');return r.json()}
  function setCount(n){count.forEach(c=>{c.textContent=n;c.style.display=n>0?'flex':'none'})}

  async function render(){
    const c=await getCart();
    setCount(c.item_count);
    if(!c.item_count){
      body.innerHTML='<div class="bm-empty">Tu cesta está vacía.</div>';
      foot.innerHTML='';return;
    }
    body.innerHTML=c.items.map(i=>`
      <div class="bm-ci" data-key="${i.key}">
        <img src="${i.image?i.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):''}" alt="">
        <div>
          <p class="bm-ci__t">${i.product_title}</p>
          <p class="bm-ci__v">${i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:''}</p>
          <div class="bm-ci__row">
            <span class="bm-qty">
              <button data-act="dec" aria-label="Quitar uno">−</button>
              <span>${i.quantity}</span>
              <button data-act="inc" aria-label="Añadir uno">+</button>
            </span>
            <strong>${money(i.final_line_price)}</strong>
          </div>
        </div>
      </div>`).join('');
    foot.innerHTML=`
      <div class="bm-cart__tot"><span>Subtotal</span><strong>${money(c.total_price)}</strong></div>
      <a href="/checkout" class="bm-btn bm-btn--block">Finalizar compra</a>
      `;
  }

  body&&body.addEventListener('click',async e=>{
    const b=e.target.closest('button[data-act]');if(!b)return;
    const row=b.closest('.bm-ci');const key=row.dataset.key;
    const q=parseInt(row.querySelector('.bm-qty span').textContent,10);
    const nq=b.dataset.act==='inc'?q+1:q-1;
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:nq})});
    render();
  });

  /* --- añadir al carrito sin recargar --- */
  $$('form[action^="/cart/add"]').forEach(f=>{
    f.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=f.querySelector('[type=submit]');const t=btn?btn.textContent:'';
      if(btn){btn.disabled=true;btn.textContent='Añadiendo…'}
      try{
        const r=await fetch('/cart/add.js',{method:'POST',body:new FormData(f)});
        if(!r.ok){const j=await r.json();alert(j.description||'No se pudo añadir');}
        else{openCart();render();}
      }catch(err){}
      if(btn){btn.disabled=false;btn.textContent=t}
    });
  });

  /* --- selector de variantes --- */
  $$('[data-bm-variants]').forEach(root=>{
    const data=JSON.parse(root.querySelector('[data-bm-variant-json]').textContent);
    const idInput=root.querySelector('input[name="id"]');
    const priceEl=root.querySelector('[data-bm-price]');
    const btn=root.querySelector('[type=submit]');
    const sel={};
    $$('.bm-opt__val',root).forEach(v=>{
      if(v.classList.contains('is-active'))sel[v.dataset.opt]=v.dataset.val;
      v.addEventListener('click',()=>{
        $$(`.bm-opt__val[data-opt="${v.dataset.opt}"]`,root).forEach(x=>x.classList.remove('is-active'));
        v.classList.add('is-active');sel[v.dataset.opt]=v.dataset.val;sync();
      });
    });
    function sync(){
      if(!btn)return;
      const want=Object.keys(sel).sort((a,b)=>a-b).map(k=>sel[k]);
      if(!want.length)return;
      const m=data.find(v=>JSON.stringify(v.options)===JSON.stringify(want));
      if(!m){btn.disabled=true;btn.textContent='No disponible';return}
      idInput.value=m.id;
      btn.disabled=!m.available;
      btn.textContent=m.available?'Añadir a la cesta':'Agotado';
      if(priceEl){
        priceEl.innerHTML=m.compare_at_price&&m.compare_at_price>m.price
          ? `<del>${money(m.compare_at_price)}</del><ins>${money(m.price)}</ins>`
          : money(m.price);
      }
      const u=new URL(location);u.searchParams.set('variant',m.id);history.replaceState({},'',u);
    }
    sync();
  });

  /* --- acordeón --- */
  $$('.bm-acc__q').forEach(q=>q.addEventListener('click',()=>q.closest('.bm-acc__item').classList.toggle('is-open')));

  render();
})();

/* v2 — aparición al scroll + barra fija de compra */
(function(){
  const els=document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window && els.length){
    const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12});
    els.forEach(e=>io.observe(e));
  } else { els.forEach(e=>e.classList.add('is-in')); }

  const sticky=document.getElementById('bmSticky');
  if(sticky){
    sticky.querySelector('button').addEventListener('click',()=>{
      const f=document.querySelector('.bm-pdp form[action^="/cart/add"]');
      if(f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
    });
  }
})();

/* la galeria sigue al color elegido */
(function(){var gal=document.querySelector('.bm-gal');if(!gal)return;var parts=location.pathname.split('/products/');if(parts.length<2)return;var h=parts[1].split('?')[0].split('#')[0].split('/')[0];fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(function(p){var byColor={};p.variants.forEach(function(v){var k=v.options[0];if(!byColor[k]&&v.featured_image&&v.featured_image.src){byColor[k]=v.featured_image.src.split('/').pop().split('?')[0];}});var items=[].slice.call(gal.querySelectorAll('.bm-gal__item'));if(!items.length)return;var show=function(c){var f=byColor[c];if(!f)return;for(var i=0;i<items.length;i++){var im=items[i].querySelector('img');if(im&&im.src.indexOf(f)>-1){gal.scrollLeft=items[i].offsetLeft-items[0].offsetLeft;return;}}};document.addEventListener('click',function(e){var b=e.target&&e.target.closest?e.target.closest('button.bm-opt__val[data-opt="0"]'):null;if(b)setTimeout(function(){show(b.getAttribute('data-val'));},0);});});})();
/* confianza en el carrito lateral */
(function(){var foot=document.getElementById('bmCartFoot');if(!foot)return;var html='<div class="bm-trust"><ul><li>Envío gratis a toda España, sin pedido mínimo</li><li>Plazo de entrega indicado en cada producto</li><li>14 días para devolver</li><li>Pago seguro y cifrado</li></ul><div class="bm-trust__pay"></div></div>';function add(){if(!foot.innerHTML.trim())return;if(foot.querySelector('.bm-trust'))return;foot.insertAdjacentHTML('beforeend',html);var s=document.querySelector('.bm-foot__pay'),d=foot.querySelector('.bm-trust__pay');if(s&&d)d.innerHTML=s.innerHTML;}new MutationObserver(add).observe(foot,{childList:true});add();})();